import { NavLink } from 'react-router-dom'
import { useState } from "react";
import styled from "@emotion/styled";

const StyledButton = styled.button`
  color: ${({ active }) => active ? '#cccccc' : 'lightgray'};
  background: ${({ active }) => active ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #666666)'};
  ${({ active }) => active && `text-shadow: lightgray 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`}
`;

const navs = [
  '/Roulette/RouletteHome',
  '/Roulette/RouletteType01',
  '/Roulette/RouletteType02',
  '/Roulette/RouletteType03',
  '/Roulette/RouletteType04',
  '/Roulette/RouletteType05',
];
const navsJ = ['ホーム', 'Type01', 'Type02', 'Type03', 'Type04', 'Type05', ];

const RouletteNavbar = () => {

  const [active, setActive] = useState(navs[0]);

  return (
    <>
      {navs.map((nav, index) => {
        return (
          <span key={index}>
            <NavLink to={nav}>
              <StyledButton key={nav}
                active={active === nav ? +true : +false }
                onClick={() => setActive(nav)}
              >{navsJ[index]}</StyledButton>
            </NavLink>
          </span>
        )}
      )}
    </>
  )
}
export default RouletteNavbar
